import axios from 'axios';

const developmentURL = 'https://api.makana.cl'; //'http://192.168.100.24:5000';
const productionURL = 'https://api.makana.cl';

export const axiosBaseInstance = axios.create({
  baseURL:
    process.env.NODE_ENV === 'production' ? productionURL : developmentURL,
});
